import { FormControl, FormLabel, HStack, Text, VStack } from "@chakra-ui/react";
import { UserInterestPayload, WorkTypes } from "../../../api/UserInterestApi";
import Switch from "../../../components/Switch/Switch";

const WorkType: React.FC<{
  onWorkTypeChange: (val: keyof WorkTypes) => void;
  formData: UserInterestPayload;
}> = ({ formData, onWorkTypeChange }) => (
  <FormControl color="grey.400" maxW="368" alignSelf="center">
    <FormLabel color="gray.500" fontSize="12px" fontWeight="700">
      What type of work are you interested in?
    </FormLabel>
    <VStack align="stretch">
      {(Object.keys(formData.workTypes) as (keyof WorkTypes)[]).map((key) => (
        <HStack key={key} justify="space-between" alignSelf="center" minW="100%">
          <Text textTransform="capitalize">{key.replace(/([A-Z])/g, " $1")}</Text>
          <Switch
            isToggled={formData.workTypes[key]}
            onToggle={() => onWorkTypeChange(key)}
            id={`switch-${key}`}
          />
        </HStack>
      ))}
    </VStack>
  </FormControl>
);

export default WorkType;
